define('modules/form_editor/models/custom_day',['require','exports','module','./base_form_element'],function(require, exports, module){
  "use strict";
  var BaseFormElement = require("./base_form_element");

  var ITEM_DEFAULT_TEXT = "Selecciona...";

  module.exports = BaseFormElement.extend({
    name: "custom:day",
    isZeroFillable: true,
    defaultValues: {
      firstOptionInvalid: true,
      fillWithZeroes: false,
      start: 1,
      end: 31,
    },
    validate: function(attrs){
      if (isNaN(attrs.start) || isNaN(attrs.end) || 
          attrs.start < 1 || attrs.end > 31 || 
          attrs.start > attrs.end) return new Error();
    },
  });
});

